import { render, staticRenderFns } from "./client-roster-display.vue?vue&type=template&id=312e5cde"
import script from "./client-roster-display.vue?vue&type=script&lang=js"
export * from "./client-roster-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports